import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { changePassword, changePasswordReset } from '../../../actions/account'
import { hideModal } from '../../../actions/_modal'
import Password from '../../mini/Password'
import Modal, { EditModalHeader, ModalBottom, ModalTop } from '../../mini/Modal'
import { Caption5, ErrorTypography } from '../../styled/typography/typography'
import { VoluntaryForm } from './_Styled'
import LoadingSpinner from '../../mini/LoadingSpinner'

const VoluntaryChange = () => {
  const dispatch = useDispatch()
  const user = useSelector(state => state.auth.user)
  const accountInfo = useSelector(state => state.account)

  const [currentPassword, setCurrentPassword] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [shouldClose, setShouldClose] = useState(false)
  
  const canSave = !!currentPassword &&
    newPassword.length >= 8 &&
    !accountInfo.isChangingPassword

  const closeTheModal = () => {
    dispatch(changePasswordReset())
    dispatch(hideModal())
  }

  const handleSave = e => {
    if (canSave) {
      dispatch(changePassword(currentPassword, newPassword))
      setShouldClose(true)
    }
    // prevent default form submission behaviour when submitted by pressing enter
    e.preventDefault()
  }

  useEffect(() => {
    if (shouldClose && accountInfo.wasPasswordChanged) {
      closeTheModal()
    }
  }, [shouldClose, accountInfo])

  return (
    <Modal
      width={660}
      allowCloseOnExternalClick={false}
      closeCallback={closeTheModal}
    >
      <EditModalHeader
        title="Change Password"
        onCancel={closeTheModal}
        onSave={handleSave}
        canCancel={!accountInfo.isChangingPassword}
        canSave={canSave}
      />

      <ModalBottom>
        {accountInfo.isChangingPassword ? (
          <LoadingSpinner isSmall />
        ) : (
          <VoluntaryForm id="frmChangePassword" onSubmit={handleSave}>
            <input type="submit" style={{ display: 'none' }} />

            {accountInfo.changePasswordErrorMessage && (
              <ErrorTypography>
                {accountInfo.changePasswordErrorMessage}
              </ErrorTypography>
            )}

            <div>
              <Caption5 htmlFor="currentPassword" as="label">
                Current Password
              </Caption5>
              <Password
                id="currentPassword"
                onChange={e => setCurrentPassword(e.target.value)}
                placeholder="Current Password"
              />
            </div>

            <div>
              <Caption5 htmlFor="newPassword" as="label">
                New Password
              </Caption5>
              <Password
                id="newPassword"
                onChange={e => setNewPassword(e.target.value)}
                placeholder="New Password"
              />
              <Caption5>Minimum 8 characters</Caption5>
            </div>
          </VoluntaryForm>
        )}
      </ModalBottom>
    </Modal>
  )
}

VoluntaryChange.propTypes = {
  onSave: PropTypes.func.isRequired,
}

export default VoluntaryChange
